
/*
 * Get first address component by type
 *
 * @param   {Object} address_components[] - Set of addresses
 * @param   {String} component_type       - Type to retrieve
 * @returns {Object|undefined}            - First address result matching type
 */
var getAddressComponentType, getAlternateAddressFormat;

getAddressComponentType = function(arg, component_type) {
  var address_components;
  address_components = arg.address_components;
  return _.find(address_components, function(arg1) {
    var types;
    types = arg1.types;
    return _.some(types, function(type) {
      return type === component_type;
    });
  });
};


/*
 * Get address name
 *
 * @param   {Object} result                      - Google maps result object
 * @param   {Array}  result.address_components[] - Array with address_components describing result
 * @param   {String} result.formatted_address    - Localized nice name for result
 * @returns {String}
 */

getAlternateAddressFormat = function(result) {
  var address;
  if ((address = getAddressComponentType(result, 'sublocality_level_1')) != null) {
    return address.short_name;
  } else if ((address = getAddressComponentType(result, 'locality')) != null) {
    return address.long_name;
  } else if ((address = getAddressComponentType(result, 'administrative_area_level_1')) != null) {
    return address.short_name;
  } else {
    return result.formatted_address;
  }
};

module.exports = {
  getAddressComponentType: getAddressComponentType,
  getAlternateAddressFormat: getAlternateAddressFormat
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvc3JjL2Zyb250ZW5kL2hlbHBlci9nZW5lcmFsL3NwZWNpYWxBZGRyZXNzQ29tcG9uZW50VHlwZS5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvVXNlcnMvYXJpY2h0ZXIvcmVwb3NpdG9yaWVzL3Nscy9zcmMvZnJvbnRlbmQvaGVscGVyL2dlbmVyYWwvc3BlY2lhbEFkZHJlc3NDb21wb25lbnRUeXBlLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7Ozs7Ozs7QUFBQSxJQUFBOztBQU9BLHVCQUFBLEdBQTBCLFNBQUMsR0FBRCxFQUF1QixjQUF2QjtBQUN4QixNQUFBO0VBRDBCLHFCQUFEO1NBQ3pCLENBQUMsQ0FBQyxJQUFGLENBQU8sa0JBQVAsRUFBMkIsU0FBQyxJQUFEO0FBQ3pCLFFBQUE7SUFEMkIsUUFBRDtXQUMxQixDQUFDLENBQUMsSUFBRixDQUFPLEtBQVAsRUFBYyxTQUFDLElBQUQ7YUFBVSxJQUFBLEtBQVE7SUFBbEIsQ0FBZDtFQUR5QixDQUEzQjtBQUR3Qjs7O0FBSTFCOzs7Ozs7Ozs7QUFRQSx5QkFBQSxHQUE0QixTQUFDLE1BQUQ7QUFDMUIsTUFBQTtFQUFBLElBQUcsMEVBQUg7V0FDRSxPQUFPLENBQUMsV0FEVjtHQUFBLE1BRUssSUFBRywrREFBSDtXQUNILE9BQU8sQ0FBQyxVQURMO0dBQUEsTUFFQSxJQUFHLGtGQUFIO1dBQ0gsT0FBTyxDQUFDLFdBREw7R0FBQSxNQUFBO1dBR0gsTUFBTSxDQUFDLGtCQUhKOztBQUxxQjs7QUFVNUIsTUFBTSxDQUFDLE9BQVAsR0FBaUI7RUFDZix5QkFBQSx1QkFEZTtFQUVmLDJCQUFBLHlCQUZlIn0=
